// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MisCitas.module.css */

.MisCitas_subtitle__CMzZ0 {
  font-size: 14px;
  color: #667085;
  margin-bottom: 20px;
  margin-top: -12px;
}

/* Toolbar */
.MisCitas_toolbar__-uJsj {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 12px;
  flex-wrap: wrap;
}

.MisCitas_tabs__xZe3Z {
  display: flex;
  gap: 6px;
}

.MisCitas_tab__7x1fb {
  padding: 7px 16px;
  border-radius: 8px;
  border: 1.5px solid #e4e7ec;
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  color: #667085;
  cursor: pointer;
  transition: all 0.15s;
}

.MisCitas_tab__7x1fb:hover {
  border-color: #2db899;
  color: #2db899;
}

.MisCitas_tabActive__0LYQs {
  background: #1a3a5c;
  border-color: #1a3a5c;
  color: #fff;
}

.MisCitas_btnNueva__Ubjz1 {
  padding: 9px 20px;
  background: #2db899;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.2s;
}

.MisCitas_btnNueva__Ubjz1:hover {
  background: #25a085;
}

/* Layout dos columnas */
.MisCitas_twoCol__QuKUT {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 16px;
  align-items: start;
}

.MisCitas_listCount__3vBxv {
  font-size: 12px;
  color: #98a2b3;
  margin-bottom: 12px;
  font-weight: 600;
}

/* Fila de cita */
.MisCitas_citaRow__7rzJE {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 10px;
  border-radius: 10px;
  cursor: pointer;
  border: 1.5px solid transparent;
  transition:
    background 0.15s,
    border-color 0.15s;
  margin-bottom: 4px;
}

.MisCitas_citaRow__7rzJE:hover {
  background: #f8fafc;
}

.MisCitas_citaRowActive__vIoHs {
  background: #f0fdf9;
  border-color: #2db899;
}

.MisCitas_citaAvatar__x922M {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e6f7f3;
  color: #2db899;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.MisCitas_citaInfo__uD-R4 {
  flex: 1 1;
}

.MisCitas_citaSpec__koL5G {
  font-size: 14px;
  font-weight: 700;
  color: #344054;
  margin-bottom: 2px;
}
.MisCitas_citaDoc__1rd5J {
  font-size: 12px;
  color: #667085;
  margin-bottom: 3px;
}
.MisCitas_citaDate__UwO2\\+ {
  font-size: 12px;
  color: #98a2b3;
}

.MisCitas_citaMeta__Rl3-4 {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
}

.MisCitas_notice__XZDp9 {
  margin-top: 16px;
  font-size: 12px;
  color: #98a2b3;
  background: #f8fafc;
  border-radius: 8px;
  padding: 10px 14px;
  line-height: 1.5;
}

/* Detalle */
.MisCitas_detail__QnOIt {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.MisCitas_detailHeader__cQfqC {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f2f4f7;
}

.MisCitas_detailAvatar__cqIkU {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #1a3a5c;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.MisCitas_detailSpec__oXAdq {
  font-size: 15px;
  font-weight: 700;
  color: #1a3a5c;
  margin-bottom: 3px;
}
.MisCitas_detailDoc__Uu3H9 {
  font-size: 13px;
  color: #667085;
}

.MisCitas_detailRow__ru1wE {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f2f4f7;
  font-size: 13px;
}

.MisCitas_detailRow__ru1wE span {
  color: #98a2b3;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.MisCitas_detailRow__ru1wE strong {
  color: #344054;
  font-weight: 600;
}

.MisCitas_btnCancelar__n2teO {
  margin-top: 20px;
  width: 100%;
  padding: 10px;
  background: transparent;
  border: 1.5px solid #fda29b;
  border-radius: 8px;
  color: #d92d20;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.MisCitas_btnCancelar__n2teO:hover {
  background: #fff1f0;
}

@media (max-width: 860px) {
  .MisCitas_twoCol__QuKUT {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MisCitas/MisCitas.module.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B;;sBAEoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* MisCitas.module.css */\n\n.subtitle {\n  font-size: 14px;\n  color: #667085;\n  margin-bottom: 20px;\n  margin-top: -12px;\n}\n\n/* Toolbar */\n.toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.tabs {\n  display: flex;\n  gap: 6px;\n}\n\n.tab {\n  padding: 7px 16px;\n  border-radius: 8px;\n  border: 1.5px solid #e4e7ec;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  color: #667085;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.tab:hover {\n  border-color: #2db899;\n  color: #2db899;\n}\n\n.tabActive {\n  background: #1a3a5c;\n  border-color: #1a3a5c;\n  color: #fff;\n}\n\n.btnNueva {\n  padding: 9px 20px;\n  background: #2db899;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: background 0.2s;\n}\n\n.btnNueva:hover {\n  background: #25a085;\n}\n\n/* Layout dos columnas */\n.twoCol {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 16px;\n  align-items: start;\n}\n\n.listCount {\n  font-size: 12px;\n  color: #98a2b3;\n  margin-bottom: 12px;\n  font-weight: 600;\n}\n\n/* Fila de cita */\n.citaRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 14px 10px;\n  border-radius: 10px;\n  cursor: pointer;\n  border: 1.5px solid transparent;\n  transition:\n    background 0.15s,\n    border-color 0.15s;\n  margin-bottom: 4px;\n}\n\n.citaRow:hover {\n  background: #f8fafc;\n}\n\n.citaRowActive {\n  background: #f0fdf9;\n  border-color: #2db899;\n}\n\n.citaAvatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #e6f7f3;\n  color: #2db899;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.citaInfo {\n  flex: 1;\n}\n\n.citaSpec {\n  font-size: 14px;\n  font-weight: 700;\n  color: #344054;\n  margin-bottom: 2px;\n}\n.citaDoc {\n  font-size: 12px;\n  color: #667085;\n  margin-bottom: 3px;\n}\n.citaDate {\n  font-size: 12px;\n  color: #98a2b3;\n}\n\n.citaMeta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 5px;\n}\n\n.notice {\n  margin-top: 16px;\n  font-size: 12px;\n  color: #98a2b3;\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 10px 14px;\n  line-height: 1.5;\n}\n\n/* Detalle */\n.detail {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.detailHeader {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f2f4f7;\n}\n\n.detailAvatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #1a3a5c;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.detailSpec {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin-bottom: 3px;\n}\n.detailDoc {\n  font-size: 13px;\n  color: #667085;\n}\n\n.detailRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid #f2f4f7;\n  font-size: 13px;\n}\n\n.detailRow span {\n  color: #98a2b3;\n  font-weight: 600;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.detailRow strong {\n  color: #344054;\n  font-weight: 600;\n}\n\n.btnCancelar {\n  margin-top: 20px;\n  width: 100%;\n  padding: 10px;\n  background: transparent;\n  border: 1.5px solid #fda29b;\n  border-radius: 8px;\n  color: #d92d20;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.btnCancelar:hover {\n  background: #fff1f0;\n}\n\n@media (max-width: 860px) {\n  .twoCol {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtitle": `MisCitas_subtitle__CMzZ0`,
	"toolbar": `MisCitas_toolbar__-uJsj`,
	"tabs": `MisCitas_tabs__xZe3Z`,
	"tab": `MisCitas_tab__7x1fb`,
	"tabActive": `MisCitas_tabActive__0LYQs`,
	"btnNueva": `MisCitas_btnNueva__Ubjz1`,
	"twoCol": `MisCitas_twoCol__QuKUT`,
	"listCount": `MisCitas_listCount__3vBxv`,
	"citaRow": `MisCitas_citaRow__7rzJE`,
	"citaRowActive": `MisCitas_citaRowActive__vIoHs`,
	"citaAvatar": `MisCitas_citaAvatar__x922M`,
	"citaInfo": `MisCitas_citaInfo__uD-R4`,
	"citaSpec": `MisCitas_citaSpec__koL5G`,
	"citaDoc": `MisCitas_citaDoc__1rd5J`,
	"citaDate": `MisCitas_citaDate__UwO2+`,
	"citaMeta": `MisCitas_citaMeta__Rl3-4`,
	"notice": `MisCitas_notice__XZDp9`,
	"detail": `MisCitas_detail__QnOIt`,
	"detailHeader": `MisCitas_detailHeader__cQfqC`,
	"detailAvatar": `MisCitas_detailAvatar__cqIkU`,
	"detailSpec": `MisCitas_detailSpec__oXAdq`,
	"detailDoc": `MisCitas_detailDoc__Uu3H9`,
	"detailRow": `MisCitas_detailRow__ru1wE`,
	"btnCancelar": `MisCitas_btnCancelar__n2teO`
};
export default ___CSS_LOADER_EXPORT___;
